export const PriceComponentType = {
  VehiclePrice: 0,
  ServiceFee: 1,
  ShippingFee: 2,
}
